var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntitiesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9645 1.58334H10.8199C10.6029 1.58409 10.3906 1.5152 10.2099 1.38542L8.93578 0.465604C8.51387 0.161017 8.01752 -0.00106705 7.50998 5.28658e-06H4.03188C3.35142 0.000791127 2.69903 0.29297 2.21787 0.812431C1.73671 1.33189 1.46608 2.03621 1.46535 2.77084V3.95834H20.531C20.531 2.43042 19.3797 1.58334 17.9645 1.58334ZM18.6863 19H3.31004C2.63661 18.9992 1.99046 18.7126 1.51093 18.2022C1.03141 17.6917 0.756945 16.9982 0.746724 16.2712L0.00701441 8.12003V8.10617C-0.0172089 7.77947 0.0214634 7.45089 0.120598 7.14111C0.219732 6.83133 0.377183 6.54706 0.583042 6.30617C0.788902 6.06529 1.03871 5.87301 1.31676 5.74144C1.5948 5.60987 1.89506 5.54185 2.19865 5.54167H19.8023C20.1058 5.54199 20.4059 5.61011 20.6839 5.74174C20.9618 5.87337 21.2115 6.06567 21.4173 6.30654C21.623 6.54741 21.7804 6.83163 21.8795 7.14135C21.9786 7.45106 22.0172 7.77956 21.993 8.10617V8.12003L21.2496 16.2712C21.2394 16.9982 20.9649 17.6917 20.4854 18.2022C20.0059 18.7126 19.3597 18.9992 18.6863 19Z",
    fill: "#45526C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntitiesIcon);
export default __webpack_public_path__ + "static/media/entities-icon.70f5a65be4a86881fecefb0de7900e6a.svg";
export { ForwardRef as ReactComponent };